export default __webpack_public_path__ + "static/media/MIDDLESEX UNIVERSITY.bb9acb00.png";